<template>
  <div class="my-jifen" v-title data-title="我的积分">
    <section>
      <div class="jifen-content">
        <!-- <p class="tixian" @click="btns">
          提现
        </p> -->
        <p class="now-jifen">
          当前积分
        </p>
        <p class="jifen-value">
          {{score}}
        </p>
        <div class="tabar">
          <p @click="score_btn(1)" :class="{'active-color':active_style==1}">
            登录积分
          </p>
          <img src="../../assets/images/pay-img/pay-record-img/2.png" alt="">
          <p @click="score_btn(2)" :class="{'active-color':active_style==2}">
            奖励积分
          </p>
        </div>
      </div>
      <p class="flash-sales">
        <img src="../../assets/images/pay-img/pay-record-img/3.png" alt="">
        温馨提示：积分达到1万可提现
      </p>
      <div class="pay-rank">
        <router-view/>
      </div>
<!--      <router-view></router-view>-->
    </section>
  </div>
</template>
<script>

import landlord from '../../components/landlord/landlord'
import Vue from 'vue';
import { Tab, Tabs, Button, Toast } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Button);
Vue.use(Toast);

export default {
  data() {
    return {
      score : 0,
      recharge_record_list: [] , // 充值记录
      score_list: [] , // 积分记录
      earnings_list: [], // 收益列表
      isbtn : false,
      active_style : 1,
      uid : '', 
    };
  },
  components:{
    landlord
  },
  created(){
    this.uid = JSON.parse(localStorage.getItem("uid"));

    this.$axios.get('http://members.kfm666666.net/api/dcash/index/balance?uid=' + this.uid).then(res => {
      // console.log(res)
      this.score = res.data.data.score
    })
  },
  methods:{
    tabBtn(index){
      if(index == 1){
        // 积分
        this.$axios.get(this.domain.url+"/api/score/index/scorelog").then((res) => {
          // console.log(res.data.data)
          this.score_list = res.data.data
        }) 
      }
    },
    // 积分提现
    btns(){
      // 查询积分
      this.$axios.post(this.domain.url+"/api/score/index/sele_score?uid=" + this.uid).then((res) => {
        // console.log(res.data)
        if(res.data < 10000){
          Toast('积分未达到一万')
        }else{
          this.$router.push('/integral-withdraw-deposit')
        }
      })
    },
    score_btn(id){
      this.active_style = id
      if(id == 1){
        this.$router.replace('/my-jifen/')
      }else if(id == 2){
        this.$router.replace('/my-jifen/award-score')
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .my-jifen{
    width: 7.5rem;
    // height: 100%;
    display: flex;
    flex-direction: column;
    background: #f9f9f9;
    section{
      width: 100%;
      height: 100%;
      overflow: scroll;
      flex: 1;
      .jifen-content{
        width: 7.5rem;
        height: 5.98rem;
        background-image: url(../../assets/images/pay-img/pay-record-img/1.png);
        background-size: 7.5rem 5.98rem;
        overflow: hidden;
        // 提现
        .tixian{
          text-align: right;
          font-size: 0.3rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          opacity: 0.7;
          line-height: .3rem;
          margin-right: .29rem;
          margin-top: .51rem;
        }
        // 当前积分
        .now-jifen{
          font-size: 0.3rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #D1D1D1;
          text-align: center;
          line-height: .3rem;
          margin-top: 2.72rem;
        }
        // 积分数值
        .jifen-value{
          text-align: center;
          font-size: 0.48rem;
          font-family: PingFang SC;
          font-weight: bold;
          color: #0F0F0F;
          line-height: .48rem;
          margin-top: .27rem;
        }
        .tabar{
          display: flex;
          font-size: 0.3rem;
          font-family: PingFang SC;
          font-weight: bold;
          color: #0F0F0F;
          margin-top: .5rem;
          p{
            width: 50%;
            text-align: center;
          }
          img{
            width: .02rem;
            height: .39rem;
          }
          .active-color{
            font-size: 0.3rem;
            font-family: PingFang SC;
            font-weight: bold;
            color: #FF9645;
          }
        }
      }
      // 限时特惠
      .flash-sales{
        width: 6.85rem;
        height: .59rem;
        margin: 0 auto;
        font-size: 0.24rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #332C24;
        margin-top: .31rem;
        display: flex;
        align-items: center;
        background: #fef8ec;
        margin-bottom: .25rem;
        img{
          width: .44rem;
          height: .44rem;
          margin-right: .52rem;
          margin-left: .1rem;
        }
      }
      .pay-rank{
        width: 100%;
      }
    }
  }
</style>